import React from "react";
import "../styles/QuickCheckout.css";
import CheckoutForm from "./StripeCheckoutForm";

export default function QuickCheckout({ isVisible, onClose, cartItems }) {
  return (
    <>
      {isVisible && (
        <div
          className="quick-checkout-overlay"
          onClick={onClose} // Close the quick checkout when clicking the overlay
        ></div>
      )}
      <div className={`checkout-panel ${isVisible ? "visible" : ""}`}>
        <div className="checkout-panel-content">
          <button className="close-button" onClick={onClose}>
            ×
          </button>
          <h2>Quick Checkout</h2>
          <p>Complete your purchase quickly!</p>
          <div className="checkout-form-placeholder">
            {isVisible && <CheckoutForm cartItems={cartItems} />}
          </div>
        </div>
      </div>
    </>
  );
}
